import { DeliveryStatisticModel } from 'api/dto/DeliveryStatistic.dto';
import { Resource } from 'model/Resource';

export const STORE_NAME = 'deliveryStatistic';

export namespace DeliveryStatisticState {
  export type Domain = {
    listResource: Resource<DeliveryStatisticModel[]>;
  };

  export const INITIAL_DOMAIN: Domain = {
    listResource: Resource.createPendingResource<DeliveryStatisticModel[]>(),
  };
}
